/**
 * Paramètres de sécurité — CCT § 5.1.
 *
 * Partagés API ↔ front : l'interface doit pouvoir annoncer « 5 tentatives »
 * ou « session expirée après 30 minutes » sans recopier les valeurs.
 *
 * Deux d'entre elles se règlent depuis l'écran Configuration, comme le CCT
 * § 5.1 l'exige (« durée de session configurable ») : le seuil de
 * verrouillage et le délai d'inactivité. Les constantes ci-dessous en sont
 * les **défauts** — la valeur d'amorçage du catalogue, et le filet quand la
 * table ne porte rien. Le code de l'API lit la table (`core/parametres`),
 * jamais directement ces deux constantes.
 *
 * Elles ne passent PAS par une variable d'environnement : le CCT § 6 veut
 * un réglage accessible à un administrateur non technique, pas un
 * redéploiement.
 */
/** Durée de vie du jeton d'accès. Court : sa révocation passe par l'expiration. */
export const DUREE_JETON_ACCES_MINUTES = 15;
/** Durée de vie du jeton de rafraîchissement, révocable en base à tout moment. */
export const DUREE_JETON_REFRESH_JOURS = 7;
/**
 * Durée de vie du jeton intermédiaire, entre le mot de passe et le code.
 *
 * Court volontairement : c'est le temps d'ouvrir son téléphone et de lire six
 * chiffres, pas celui d'aller déjeuner.
 */
export const DUREE_SECOND_FACTEUR_MINUTES = 5;
/**
 * Au-delà de ce silence, la session d'un rôle transverse est invalidée (CCT
 * § 5.1). 120 min comme les postes de site (décision 422) : la chargée de
 * clientèle subit les mêmes délestages que le guichet.
 */
export const DUREE_INACTIVITE_MINUTES = 120;
/**
 * Au-delà de ce silence, la session d'un poste de site est invalidée
 * (décision 417) : un délestage de moins de deux heures ne déconnecte
 * personne au guichet. Même valeur que pour les rôles transverses (décision
 * 422), mais un paramètre distinct dans Configuration.
 */
export const DUREE_INACTIVITE_POSTE_SITE_MINUTES = 120;
/**
 * En-tête posé par le navigateur sur une requête qu'aucune action de
 * l'utilisateur n'a déclenchée (relecture après un signal temps réel, au
 * retour du réseau…). Elle ne compte pas comme activité : un poste allumé
 * et oublié doit se fermer (décision 417).
 */
export const ENTETE_ARRIERE_PLAN = 'x-afs-arriere-plan';
/** Ce que porte la réponse 401 d'une session fermée pour inactivité. */
export const RAISON_SESSION_INACTIVE = 'SESSION_INACTIVE';
/**
 * Verrouillage du compte après N échecs consécutifs.
 * **Aucun déverrouillage automatique après délai** : seul un administrateur
 * rouvre le compte (CCT § 5.1). C'est volontaire, et c'est plus strict que
 * l'usage courant.
 */
export const TENTATIVES_AVANT_VERROUILLAGE = 5;
/**
 * Durée de validité d'un lien de réinitialisation de mot de passe.
 *
 * Trente minutes : le temps d'ouvrir sa boîte et de cliquer, pas celui de
 * laisser traîner un lien actif dans une messagerie professionnelle qu'un
 * collègue peut consulter sur un poste partagé.
 *
 * Le front l'affiche à l'écran ET l'API l'applique : c'est le même chiffre,
 * il ne peut donc pas y avoir de promesse non tenue.
 */
export const DUREE_LIEN_REINITIALISATION_MINUTES = 30;
/**
 * Fréquence maximale de mise à jour de l'horodatage d'activité.
 *
 * Sans ce palier, chaque requête authentifiée déclencherait une écriture en
 * base : sur 35 utilisateurs actifs, c'est un `UPDATE` par clic, pour une
 * information dont la précision à la minute suffit largement.
 */
export const PALIER_ACTIVITE_SECONDES = 60;
//# sourceMappingURL=securite.js.map